import { useEffect, useState } from "react";
import { Backend } from "../url";

export interface IResearch {
  experiment_id: string;
  legacy_id: string;
  chl_product: string;
  peg_product: string;
  title: string;
  doi: string;
  lnp_count: number;
  lnp_unique_count: number;
  author: string;
  journal: string;
}

export interface ITotal {
  lnp_count: number;
  unique_count: number;
}

export const useResearchData = () => {
  const [projects, setProjects] = useState<IResearch[]>([]);
  const [totalCount, setTotalCount] = useState<ITotal>({
    lnp_count: 0,
    unique_count: 0,
  });
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchProjects = async () => {
      setIsLoading(true);

      try {
        const response = await fetch(`${Backend}/search/metadata/`);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        const response2 = await fetch(`${Backend}/search/il_count/`);

        const data: IResearch[] = await response.json();
        setProjects(data);

        const cnt = await response2.json();
        const tempTotalLnpUniqueCount = cnt.count;

        const tempTotalLnpCount = data.reduce(
          (sum, item) => sum + item.lnp_count,
          0
        );

        setTotalCount({
          lnp_count: tempTotalLnpCount,
          unique_count: tempTotalLnpUniqueCount,
        });
      } catch (error) {
        console.error("Error fetching projects:", error);
        setError(error instanceof Error ? error.message : "Unknown error");
      } finally {
        setIsLoading(false);
      }
    };

    fetchProjects();
  }, []);

  return { projects, totalCount, isLoading, error };
};
